import React from 'react';
import MoneyInput from './MoneyInput';
import { formatMontantCAD } from '../utils/formatters';

const fmt = (v) => formatMontantCAD(v);

const ActifRow = React.memo(({ label, valReq, valFam, onChangeReq, onChangeFam, disabledFam, tabReq, tabFam }) => (
  <tr>
    <td style={{ padding: '4px 8px' }}>{label}</td>
    <td style={{ padding: '4px 4px' }}>
      <MoneyInput value={valReq} onChange={onChangeReq} tabIndex={tabReq} />
    </td>
    <td style={{ padding: '4px 4px' }}>
      <MoneyInput value={valFam} onChange={onChangeFam} disabled={disabledFam} tabIndex={tabFam} />
    </td>
  </tr>
));

const ReadOnlyRow = ({ label, valReq, valFam, total }) => (
  <tr style={{ background: '#e8eef4' }}>
    <td style={{ padding: '4px 8px', fontWeight: 'bold', textTransform: 'uppercase' }}>{label}</td>
    {total !== undefined ? (
      <td colSpan={2} style={{ padding: '4px 8px', textAlign: 'right', fontWeight: 'bold' }}>{fmt(total)}</td>
    ) : (
      <>
        <td style={{ padding: '4px 8px', textAlign: 'right', fontWeight: 'bold' }}>{fmt(valReq)}</td>
        <td style={{ padding: '4px 8px', textAlign: 'right', fontWeight: 'bold' }}>{fmt(valFam)}</td>
      </>
    )}
  </tr>
);

const ActifsTab = ({ formData, updateActifs }) => {
  const disabled = !formData.revenus?.famille_incluse;
  const a = formData.actifs;

  const sousTotalReq = (a.residence_req || 0) + (a.autres_immeubles_req || 0) + (a.regime_retraite_req || 0) + (a.autres_biens_req || 0);
  const sousTotalFam = (a.residence_fam || 0) + (a.autres_immeubles_fam || 0) + (a.regime_retraite_fam || 0) + (a.autres_biens_fam || 0);
  const totalBienReq = sousTotalReq - (a.moins_dettes_req || 0);
  const totalBienFam = sousTotalFam - (a.moins_dettes_fam || 0);
  const totalBiens = totalBienReq + totalBienFam;

  const totalLiqReq = (a.argent_especes_req || 0) + (a.depot_terme_req || 0) + (a.autres_liquidites_req || 0);
  const totalLiqFam = (a.argent_especes_fam || 0) + (a.depot_terme_fam || 0) + (a.autres_liquidites_fam || 0);
  const totalLiquidites = totalLiqReq + totalLiqFam;

  // Biens: Req 1-5, Fam 6-10
  // Liquidités: Req 11-13, Fam 14-16
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
      <fieldset className="win-groupbox compact">
        <legend>Biens</legend>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#c8d8e8' }}>
              <th style={{ textAlign: 'left', padding: '6px 8px', width: '55%' }}></th>
              <th style={{ textAlign: 'center', padding: '6px 8px', width: '22.5%' }}>Requérant</th>
              <th style={{ textAlign: 'center', padding: '6px 8px', width: '22.5%' }}>Famille</th>
            </tr>
          </thead>
          <tbody>
            <ActifRow label="Résidence" valReq={a.residence_req} valFam={a.residence_fam} onChangeReq={v => updateActifs('residence_req', v)} onChangeFam={v => updateActifs('residence_fam', v)} disabledFam={disabled} tabReq={1} tabFam={6} />
            <ActifRow label="Autres immeubles" valReq={a.autres_immeubles_req} valFam={a.autres_immeubles_fam} onChangeReq={v => updateActifs('autres_immeubles_req', v)} onChangeFam={v => updateActifs('autres_immeubles_fam', v)} disabledFam={disabled} tabReq={2} tabFam={7} />
            <ActifRow label="Régime de ret. non imp." valReq={a.regime_retraite_req} valFam={a.regime_retraite_fam} onChangeReq={v => updateActifs('regime_retraite_req', v)} onChangeFam={v => updateActifs('regime_retraite_fam', v)} disabledFam={disabled} tabReq={3} tabFam={8} />
            <ActifRow label="Autres biens" valReq={a.autres_biens_req} valFam={a.autres_biens_fam} onChangeReq={v => updateActifs('autres_biens_req', v)} onChangeFam={v => updateActifs('autres_biens_fam', v)} disabledFam={disabled} tabReq={4} tabFam={9} />
            <ReadOnlyRow label="Sous-total" valReq={sousTotalReq} valFam={sousTotalFam} />
            <ActifRow label="Moins dettes" valReq={a.moins_dettes_req} valFam={a.moins_dettes_fam} onChangeReq={v => updateActifs('moins_dettes_req', v)} onChangeFam={v => updateActifs('moins_dettes_fam', v)} disabledFam={disabled} tabReq={5} tabFam={10} />
            <ReadOnlyRow label="Total" valReq={totalBienReq} valFam={totalBienFam} />
            <ReadOnlyRow label="Total des biens" total={totalBiens} />
          </tbody>
        </table>
      </fieldset>

      <fieldset className="win-groupbox compact">
        <legend>Liquidités</legend>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#c8d8e8' }}>
              <th style={{ textAlign: 'left', padding: '6px 8px', width: '55%' }}></th>
              <th style={{ textAlign: 'center', padding: '6px 8px', width: '22.5%' }}>Requérant</th>
              <th style={{ textAlign: 'center', padding: '6px 8px', width: '22.5%' }}>Famille</th>
            </tr>
          </thead>
          <tbody>
            <ActifRow label="Argent en espèces ou en biens" valReq={a.argent_especes_req} valFam={a.argent_especes_fam} onChangeReq={v => updateActifs('argent_especes_req', v)} onChangeFam={v => updateActifs('argent_especes_fam', v)} disabledFam={disabled} tabReq={11} tabFam={14} />
            <ActifRow label="Dépôts à terme" valReq={a.depot_terme_req} valFam={a.depot_terme_fam} onChangeReq={v => updateActifs('depot_terme_req', v)} onChangeFam={v => updateActifs('depot_terme_fam', v)} disabledFam={disabled} tabReq={12} tabFam={15} />
            <ActifRow label="Autres liquidités" valReq={a.autres_liquidites_req} valFam={a.autres_liquidites_fam} onChangeReq={v => updateActifs('autres_liquidites_req', v)} onChangeFam={v => updateActifs('autres_liquidites_fam', v)} disabledFam={disabled} tabReq={13} tabFam={16} />
            <ReadOnlyRow label="Total" valReq={totalLiqReq} valFam={totalLiqFam} />
            <ReadOnlyRow label="Liquidités totales" total={totalLiquidites} />
          </tbody>
        </table>
      </fieldset>
    </div>
  );
};

export default ActifsTab;
